import React from 'react';
import { useNavigate } from 'react-router-dom';
const WireframeHomePage = () => {
  const navigate = useNavigate();
  return <div className="w-full bg-white p-3 font-mono text-[11px]" data-id="element-332">
      {/* Wireframe Header */}
      <header className="border border-dashed border-gray-400 p-2 mb-4" data-id="element-333">
        <div className="flex justify-between items-center" data-id="element-334">
          <div className="bg-gray-300 h-6 w-20 flex items-center justify-center text-[10px] text-gray-600" data-id="element-335">
            LOGO
          </div>
          <div className="flex gap-2" data-id="element-336">
            <div className="bg-gray-200 h-5 w-12 flex items-center justify-center text-[10px] text-gray-500" data-id="element-337">
              Nav
            </div>
            <div className="bg-gray-200 h-5 w-12 flex items-center justify-center text-[10px] text-gray-500" data-id="element-338">
              Nav
            </div>
            <div className="bg-gray-200 h-5 w-12 flex items-center justify-center text-[10px] text-gray-500" data-id="element-339">
              Nav
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section Wireframe */}
      <section className="border border-dashed border-gray-400 p-4 mb-4" data-id="element-340">
        <div className="flex flex-col md:flex-row gap-4" data-id="element-341">
          {/* Content Side */}
          <div className="md:w-1/2 space-y-2" data-id="element-342">
            <div className="bg-gray-300 h-8 w-full flex items-center px-2 text-[11px] text-gray-600" data-id="element-343">
              H1: Main Headline
            </div>
            <div className="bg-gray-200 h-5 w-3/4 flex items-center px-2 text-[10px] text-gray-500" data-id="element-344">
              Subheading / Value proposition
            </div>

            {/* Postcode Search Wireframe */}
            <div className="border border-gray-400 p-3 mt-3" data-id="element-345">
              <div className="bg-gray-200 h-4 w-32 mb-2 flex items-center px-2 text-[10px] text-gray-500" data-id="element-346">
                Label: Find services
              </div>
              <div className="flex gap-2" data-id="element-347">
                <div className="flex-1 border border-gray-400 h-8 flex items-center px-2 text-[10px] text-gray-500" data-id="element-348">
                  [Postcode Input]
                </div>
                <div className="bg-gray-400 h-8 w-20 flex items-center justify-center text-[10px] text-white" data-id="element-349">
                  CTA
                </div>
              </div>
            </div>
          </div>

          {/* Image Placeholder */}
          <div className="md:w-1/2" data-id="element-350">
            <div className="bg-gray-200 border border-dashed border-gray-400 h-40 flex items-center justify-center" data-id="element-351">
              <div className="text-center text-gray-500" data-id="element-352">
                <div className="text-2xl mb-1" data-id="element-353">🖼</div>
                <div className="text-[10px]" data-id="element-354">Hero Image</div>
                <div className="text-[9px]" data-id="element-355">800 × 600</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Annotation */}
      <div className="text-[9px] text-gray-400 text-center mb-3" data-id="element-356">
        Wireframe v1.0 — Homepage / Landing
      </div>

      {/* Navigation */}
      <div className="flex justify-center gap-2" data-id="element-357">
        <button onClick={() => navigate('/wireframe/services')} className="border border-gray-400 px-3 py-1.5 text-[10px] text-gray-600 hover:bg-gray-100" data-id="element-358">
          → Services
        </button>
        <button onClick={() => navigate('/wireframe/booking')} className="border border-gray-400 px-3 py-1.5 text-[10px] text-gray-600 hover:bg-gray-100" data-id="element-359">
          → Booking
        </button>
      </div>
    </div>;
};
export default WireframeHomePage;